const faqs = [
  {
    id: 1,
    heading: "What types of water delivery services are available?",
    content: "We offer a variety of water delivery services including bottled water delivery for homes and offices, bulk water supply for commercial use, and scheduled or on-demand delivery options to meet your hydration needs.",
  },
  {
    id: 2,
    heading: "How often do I need to schedule water deliveries?",
    content: "Water deliveries can be scheduled based on your consumption needs—daily, weekly, bi-weekly, or monthly. We also offer flexible plans that can be adjusted at any time to fit your changing requirements.",
  },
  {
    id: 3,
    heading: "What is the cost of using a water delivery service?",
    content: "The cost depends on the type and volume of water you need, delivery frequency, and service location. We offer competitive pricing with transparent billing and customizable packages for homes and businesses.",
  },
  {
    id: 4,
    heading: "What types of water dispensers are available?",
    content: "We provide a range of dispensers including top-load, bottom-load, countertop, and touchless dispensers. All models are compatible with our bottled water and designed for convenience, hygiene, and energy efficiency.",
  },
];

export default faqs;